import React from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { bewizrLibraryStore } from '~/stores'
import { observer } from '~/ui/component'
import { HBox, PushButton } from '~/ui/components'
import { AppLayoutConfig } from '~/ui/layouts'
import BeWizrLibraryView from './BeWizrLibraryView'
import { BeWizrLibraryItemType } from '~/models'
import { layout } from '~/ui/styling'

export type Props = RouteComponentProps

const BeWizrLibraryScreen = observer('BeWizrLibraryScreen', (props: Props) => {

  const [t] = useTranslation('bewizr-library')

  const endpoint           = bewizrLibraryStore.allItems
  const topicID            = endpoint.param('topic')
  const topicDocument      = topicID == null ? null : bewizrLibraryStore.topics.document(topicID)
  const topicsEndpint      = bewizrLibraryStore.allTopics
  const categoriesEndpoint = topicDocument?.categoriesEndpoint
  const fetchStatus        = endpoint.fetchStatus

  //------
  // Rendering

  function render() {
    return (
      <>
        <AppLayoutConfig
          title={t('title')}
          ActionsComponent={renderActions}
          fetchStatus={fetchStatus}
        />
        <BeWizrLibraryView
          endpoint={endpoint}
          filters={{
            type:     BeWizrLibraryItemType.all.filter(it => it !== 'occurrence'),
            topic:    {endpoint: topicsEndpint},
            category: categoriesEndpoint == null ? false : {endpoint: categoriesEndpoint},
          }}
        />
      </>
    )
  }

  function renderActions() {
    return (
      <HBox gap={layout.padding.inline.s}>
        <PushButton
          icon='calendar'
          caption={t('calendar.show')}
          href='/bewizr-library/calendar'
          small
        />
      </HBox>
    )
  }

  return render()

})

export default BeWizrLibraryScreen